/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectLocationTypes = (state: { locationTypes: any }) => state.locationTypes.entities;
export const selectLocationTypesLoading = (state: { locationTypes: any }) => state.locationTypes.isLoading;
export const selectLocationTypesError = (state: { locationTypes: any }) => state.locationTypes.error;
